<div class="has-validation position-relative" [class.form-floating]="inIsLabelRequired()">
  <input #autocompleteInput (ngModelChange)="changeAddress($event)" class="form-control" (focusout)="onFocusOut($event)" [autocomplete]="autocompleteOff() ? 'off' : 'on'"
    [class.is-invalid]="!isLoadingContent() && ((!hasDeliveryAddressCoverage() && isGoogleAddressFilled()) || controlHasError())"
    [(ngModel)]="queryString" [class.is-valid]="!isLoadingContent() && hasDeliveryAddressCoverage()" id="address"
    [placeholder]="label()" (input)="changeAddress($event)">
  @if (inIsLabelRequired()) {
  <label for="address">{{label()}}</label>
  }
  @if (isLoadingContent()) {
  <mat-progress-bar mode="indeterminate" value="accent"></mat-progress-bar>
  } @else if (inShowDefaultMessages()) {
  @if (hasDeliveryAddressCoverage()) {
  <div class="valid-tooltip">
    This address is in our delivery area!
  </div>
  } @else if (isGoogleAddressFilled()) {
  <div class="invalid-tooltip">
    Oops! Your address isn't in our delivery zone.
  </div>
  } @else if(controlHasError()) {
  <div class="invalid-tooltip">
    You should select a valid address.
  </div>
  }
  }
</div>